module.exports = __webpack_public_path__ + "img/金牛座.ce38c479.svg";